module.exports = __webpack_public_path__ + "assets/img/2818.662598a9.svg";